/**
 * GitHub Secret patterns:
 *
 * 1. GitHub Personal Access Token (classic):
 *    - Starts with 'ghp_'
 *    - Followed by 36 alphanumeric characters
 *    - Total length: 40 characters
 *
 * 2. GitHub OAuth Access Token:
 *    - Starts with 'gho_'
 *    - Followed by 36 alphanumeric characters
 *    - Total length: 40 characters
 *
 * 3. GitHub App Token:
 *    - Starts with 'ghs_'
 *    - Followed by 36 alphanumeric characters
 *    - Total length: 40 characters
 *
 * 4. GitHub Refresh Token:
 *    - Starts with 'ghr_'
 *    - Followed by 36 alphanumeric characters
 *
 * 5. GitHub Fine-grained Personal Access Token:
 *    - Starts with 'github_pat_'
 *    - Followed by alphanumeric characters and underscores
 *
 * Examples:
 * - Personal Access Token: `ghp_1234567890abcdefghijklmnopqrstuvwxyz`
 * - OAuth Token: `gho_1234567890abcdefghijklmnopqrstuvwxyz`
 * - App Token: `ghs_1234567890abcdefghijklmnopqrstuvwxyz`
 * - Fine-grained: `github_pat_11AAAAAA1234567890_abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ`
 *
 * References:
 * - https://github.com/secretlint/secretlint/blob/master/packages/%40secretlint/secretlint-rule-github/src/index.ts
 * - https://docs.github.com/en/authentication/keeping-your-account-and-data-secure/about-authentication-to-github
 * - https://github.blog/2021-04-05-behind-githubs-new-authentication-token-formats/
 */

export const githubPersonalAccessToken = /\bghp_[A-Za-z0-9]{36}\b/;
export const githubOAuthToken = /\bgho_[A-Za-z0-9]{36}\b/;
export const githubAppToken = /\bghs_[A-Za-z0-9]{36}\b/;
export const githubRefreshToken = /\bghr_[A-Za-z0-9]{36}\b/;
export const githubFineGrainedToken = /\bgithub_pat_[A-Za-z0-9_]{82}\b/;
